import React, { useMemo, useState } from 'react';
import { Bubble } from 'tea-component';
import ChannelLabel from '@/pages/opinion/components/ChannelLabel';
import { useDealwithPlatform } from '../../hooks';
import './index.scss';
import { useIntl } from 'umi';
import CardCommon from '@/pages/opinion/components/CardCommon';
import {
  formatSimpleTimeFunc,
  formatTimeToShow,
} from '@/pages/opinion/utils/time';
import UserScoreBox from '@/pages/opinion/components/UserScoreCommon';

import xbox from '@/pages/opinion/assets/svg/channel/xbox_img.svg';
import SvgIcon from '@home/components/SvgIcon';
import useHasMenu from '@op/hooks/useHasMenu';

export default function GamePCScoreBox({
  storeScoreInfo,
  steamReviews,
  loading,
  changeTime,
  show,
  time,
  isToday,
  xboxRatingInfo,
  xboxRatings,
  filter,
}: any) {
  const {
    metacriticElement,
    opencriticElement,
    steamElement,
    steamReviewElement,
  } = useDealwithPlatform({
    data: storeScoreInfo,
    setTime: changeTime,
    isToday,
    show,
    steamReviews,
  });
  const { formatMessage } = useIntl();
  const timeFormat = useMemo(() => {
    return filter?.date_type === 'hourly'
      ? 'YYYY-MM-DD HH:mm:ss'
      : 'YYYY-MM-DD';
  }, [filter]);

  // 展开折叠
  const [isShow, setIsShow] = useState(true);

  const { hasMenu } = useHasMenu('Steam Performance', { gameType: 'pc' });

  return (
    <CardCommon
      loading={loading}
      loadingHeight={280}
      contentCard
      className="dbo-feeds-storescorebox-page"
    >
      <>
        <div
          className={`feeds-storescorebox ${isShow ? 'dbo-storescorebox' : ''}`}
        >
          {/* 新加结构 */}
          {hasMenu && (
            <>
              <div className="storescorebox-item">
                <div className="storescorebox-item-bd">
                  <div className="storescorebox-item-flex --relative">
                    <div className="dbo-storescorebox-hd">
                      {/* <ChannelLabel
                        className="storescorebox-item-hd-icon"
                        channel_name={'steam'}
                        showText={false}
                        style={{ marginRight: 10 }}
                      ></ChannelLabel> */}
                      <div className="storescorebox-item-hd-icon">
                        <SvgIcon type="new-logo"></SvgIcon>
                      </div>
                      <Bubble content={null} dark closeOnScroll>
                        <div className="storescorebox-item-flex-title">
                          {formatMessage({ id: 'Steam Added Reviews' })}
                        </div>
                      </Bubble>
                    </div>
                    <div className="storescorebox-item-flex-time --max-width">
                      {formatTimeToShow({
                        ...filter,
                        link_text: '\n~ ',
                      })}
                    </div>
                  </div>
                  <div className="storescorebox-item-progress">
                    {steamReviewElement}
                  </div>
                </div>
              </div>
              <div className="storescorebox-item">
                <div className="storescorebox-item-bd">
                  <div className="storescorebox-item-flex">
                    <div className="dbo-storescorebox-hd">
                      <ChannelLabel
                        className="storescorebox-item-hd-icon"
                        channel_name={'steam'}
                        showText={false}
                        style={{ marginRight: 10 }}
                      ></ChannelLabel>
                      <Bubble content={null} dark closeOnScroll>
                        <div className="storescorebox-item-flex-title">
                          {formatMessage({ id: 'All Reviews' })}
                        </div>
                      </Bubble>
                    </div>

                    <div className="storescorebox-item-flex-time">
                      {time.steam &&
                        formatSimpleTimeFunc(time.steam, timeFormat)}
                    </div>
                  </div>

                  <div className="storescorebox-item-progress">
                    {steamElement}
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="storescorebox-item">
            <div className="storescorebox-item-bd">
              <div className="storescorebox-item-flex">
                <div className="dbo-storescorebox-hd">
                  <ChannelLabel
                    className="storescorebox-item-hd-icon"
                    channel_name={'opencritic'}
                    showText={false}
                    style={{ marginRight: 10 }}
                  ></ChannelLabel>
                  <Bubble content={null} dark closeOnScroll>
                    <div className="storescorebox-item-flex-title">
                      {formatMessage({ id: 'Lifetime Reviews' })}
                    </div>
                  </Bubble>
                </div>

                <div className="storescorebox-item-flex-time">
                  {time.opencritic &&
                    formatSimpleTimeFunc(time.opencritic, timeFormat)}
                </div>
              </div>
              <div className="storescorebox-item-progress">
                {opencriticElement}
              </div>
            </div>
          </div>

          <div className="storescorebox-item">
            <div className="storescorebox-item-bd">
              <div className="storescorebox-item-flex">
                <div className="dbo-storescorebox-hd">
                  <ChannelLabel
                    className="storescorebox-item-hd-icon"
                    channel_name={'metacritic'}
                    showText={false}
                    style={{ marginRight: 10 }}
                  ></ChannelLabel>
                  <Bubble content={null} dark closeOnScroll>
                    <div className="storescorebox-item-flex-title">
                      {formatMessage({ id: 'Lifetime Reviews' })}
                    </div>
                  </Bubble>
                </div>

                <div className="storescorebox-item-flex-time">
                  {time.metacritic &&
                    formatSimpleTimeFunc(time.metacritic, timeFormat)}
                </div>
              </div>

              <div className="storescorebox-item-progress">
                {metacriticElement}
              </div>
            </div>
          </div>
          {xboxRatings.map(({ ratingKey, title }: any) => (
            <div className="storescorebox-item" key={title}>
              <UserScoreBox
                type={ratingKey}
                title={title}
                filter={filter}
                platform="xbox"
                data={xboxRatingInfo?.[ratingKey]}
                isFeeds
              />
            </div>
          ))}
        </div>
        {hasMenu && (
          <div
            className="feeds-userscorebox-more"
            onClick={() => setIsShow(!isShow)}
          >
            <span>{formatMessage({ id: isShow ? 'Show' : 'Show Less' })}</span>
            {isShow ? (
              <img className="feeds-userscorebox-more-img" src={xbox} />
            ) : null}
          </div>
        )}
      </>
    </CardCommon>
  );
}
